import { lazy, Suspense } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { Loader2 } from 'lucide-react'
import AppLayout from '@/components/layout/AppLayout'
import ProtectedRoute from '@/components/auth/ProtectedRoute'
import { UserPropertyEnricher } from '@/components/UserPropertyEnricher'
import SignInPage from '@/routes/SignInPage'
import SignUpPage from '@/routes/SignUpPage'
import { useDocumentTitle } from '@/hooks/useDocumentTitle'

const DashboardPage = lazy(() => import('@/routes/Dashboard'))
const DesignsPage = lazy(() => import('@/routes/DesignsPage'))
const UploadPage = lazy(() => import('@/routes/UploadPage'))
const DesignDetailPage = lazy(() => import('@/routes/DesignDetailPage'))
const BatchesPage = lazy(() => import('@/routes/BatchesPage'))
const BatchDetailPage = lazy(() => import('@/routes/BatchDetailPage'))
const BillingPage = lazy(() => import('@/routes/BillingPage'))
const TasksPage = lazy(() => import('@/routes/TasksPage'))

function PageFallback() {
  return (
    <div className="flex items-center justify-center py-24">
      <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
    </div>
  )
}

const App = () => {
  useDocumentTitle()

  return (
    <Routes>
      {/* Public auth routes */}
      <Route path="/sign-in/*" element={<SignInPage />} />
      <Route path="/sign-up/*" element={<SignUpPage />} />

      {/* Protected app routes */}
      <Route
        element={
          <ProtectedRoute>
            <>
              <UserPropertyEnricher />
              <AppLayout />
            </>
          </ProtectedRoute>
        }
      >
        <Route path="/" element={<Suspense fallback={<PageFallback />}><DashboardPage /></Suspense>} />
        <Route path="/designs" element={<Suspense fallback={<PageFallback />}><DesignsPage /></Suspense>} />
        <Route path="/designs/upload" element={<Suspense fallback={<PageFallback />}><UploadPage /></Suspense>} />
        <Route path="/designs/:id" element={<Suspense fallback={<PageFallback />}><DesignDetailPage /></Suspense>} />
        <Route path="/batches" element={<Suspense fallback={<PageFallback />}><BatchesPage /></Suspense>} />
        <Route path="/batches/:id" element={<Suspense fallback={<PageFallback />}><BatchDetailPage /></Suspense>} />
        <Route path="/billing" element={<Suspense fallback={<PageFallback />}><BillingPage /></Suspense>} />
        <Route path="/tasks" element={<Suspense fallback={<PageFallback />}><TasksPage /></Suspense>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  )
}

export default App
